import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App"; // <--- This imports the FUNCTION from App.js

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

